const sessionSelector = (state) => state.session;
const isStudentSelector = (state) => state.session.isStudent;
const isUserAvatarLoadedSelector = (state) => state.session.isUserAvatarLoaded;

export { sessionSelector, isUserAvatarLoadedSelector, isStudentSelector };
